import { render, staticRenderFns } from "./frozenThaw.vue?vue&type=template&id=2b0ea9ba"
import script from "./frozenThaw.vue?vue&type=script&lang=js"
export * from "./frozenThaw.vue?vue&type=script&lang=js"
import style0 from "./frozenThaw.vue?vue&type=style&index=0&id=2b0ea9ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports